var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
const getPrices = () => __awaiter(void 0, void 0, void 0, function* () {
    let prices;
    try {
        const response = yield (yield fetch(`https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,steem,steem-dollars&vs_currencies=usd&include_24hr_change=true`)).json();
        // {"bitcoin":{"usd":95055},"steem":{"usd":0.169783},"steem-dollars":{"usd":0.429379}}
        if (response) {
            prices = Object.assign(Object.assign({}, response), { steem_dollars: {
                    usd: response['steem-dollars'].usd,
                    usd_24h_change: response['steem-dollars'].usd_24h_change,
                } });
            prices;
            yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.LAST_PRICE, prices);
        }
        else {
            Logger.error('Cannot fetch prices from API. Using last known price...');
            prices = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAST_PRICE);
        }
    }
    catch (err) {
        Logger.error('Cannot fetch prices from API. Using last known price...', err);
        prices = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAST_PRICE);
    }
    finally {
        return prices !== null && prices !== void 0 ? prices : {};
    }
});
const getBittrexCurrency = (currency) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch('https://api.bittrex.com/api/v1.1/public/getcurrencies', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });
    if (response.status === 200) {
        return (yield response.json()).find((c) => c.Currency == currency);
    }
    return null;
});
const CurrencyPricesUtils = {
    getBittrexCurrency,
    getPrices,
};
export default CurrencyPricesUtils;
